module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subscript"
  }, [_c('div', {
    staticClass: "page-subscript-part"
  }, [_c('div', {
    staticClass: "page-subscript-container"
  }, [_c('mt-subscript', {
    attrs: {
      "label": "成功",
      "fontsize": "12px",
      "background": "red",
      "width": "90px",
      "height": "16px",
      "rotate": "45"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a581cf0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/subscript.vue
// module id = 617
// module chunks = 0